import React, { useRef } from 'react';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { StyledEntity } from '../Entity/Entity.styles';
import { TruncatedText } from '../../../CommonComponents/OPL/Text/TruncatedText';
import { useRouteParams } from '../../hooks/useRouteParams';
import { UploadProgress } from '../UploadProgress/UploadProgress';
import { ColumnWidths, UploadProgressRef } from '../../DocumentVault.meta';
import { UploadFileData } from '../../state/reducer';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { useInternalFileUploadMutation } from '../../api/useInternalFileUploadMutation';
import { useClientId } from '../../../_hooks/useClientId';

interface Props {
  fileId: string;
  file: UploadFileData;
}

export const UploadFile: React.FC<Props> = ({ fileId, file: { file, path } }) => {
  const uploadProgressRef = useRef<UploadProgressRef>(null);

  const clientId = useClientId();

  const { path: routePath, providerType } = useRouteParams();

  const { mutateAsync: uploadFile } = useInternalFileUploadMutation({
    uploadProgressRef,
    providerType,
  });

  useEffectOnce(() => {
    (async () => {
      try {
        await uploadFile({
          clientId: clientId.toString(),
          path: decodeURIComponent(path),
          fileId,
          file,
        });
      } catch (err) {
        if (err instanceof Error) {
          toast.error(err.message);
        }
      }
    })();
  });

  return (
    <StyledEntity
      css={`
        display: ${path === routePath ? 'flex' : 'none'};
      `}
    >
      <Box display="flex" flex={ColumnWidths.Name} alignItems="center">
        <Icon className="far fa-file-alt" color="neutral.500" mr="4" />

        <TruncatedText fontWeight={500}>{file.name}</TruncatedText>
      </Box>

      <UploadProgress ref={uploadProgressRef} width={280} />
    </StyledEntity>
  );
};
